export const content = `## On mobile

1. When you login to your account, use the menu icon to open your navigation menu.
2. Select [**Insurance**](/insurance).
3. If you already have insurance information, use **Edit**. Otherwise, select Add Insurance.
4. Add information about your health plan, including your provider, member ID, and whether your plan is Medicaid.
5. Upload a photo of the front and back of your insurance card.
6. Confirm whether or not you’re the Primary Subscriber. If you’re not, enter their information.
   - If you were added to your insurance plan by someone else, you might not be the primary subscriber.
     The **primary subscriber** is the main person on the insurance plan. Also called the "policy holder," this person owns the plan because they might pay the premiums for it or they get insurance through work.
7. Select **Save**.

## On desktop

1. When you login to your account, go to [**Insurance**](/insurance) from your sidebar navigation.
2. If you already have insurance information, use **Edit**. Otherwise, select Add Insurance.
3. Add information about your health plan, including your provider, member ID, and whether your plan is Medicaid.
4. Upload a photo of the front and back of your insurance card.
5. Confirm whether or not you’re the Primary Subscriber. If you’re not, enter their information.
   - If you were added to your insurance plan by someone else, you might not be the primary subscriber.
     The **primary subscriber** is the main person on the insurance plan. Also called the "policy holder," this person owns the plan because they might pay the premiums for it or they get insurance through work.
6. Select **Save**.
`;
